import {
  Card,
  CardHeader,
  CardBody,
  Text,
  Table,
  useTable,
  CellText,
  type ColumnConfig,
} from '@backstage/ui';
import { useApi, configApiRef } from '@backstage/core-plugin-api';

interface BuildInfoRow {
  id: string;
  key: string;
  value: string;
}

const columns: ColumnConfig<BuildInfoRow>[] = [
  {
    id: 'key',
    label: 'Property',
    isRowHeader: true,
    cell: row => <CellText title={row.key} />,
  },
  {
    id: 'value',
    label: 'Value',
    cell: row => <CellText title={row.value} />,
  },
];

/**
 * BuildInfoCard component displays build version and timestamp information.
 *
 * The values are read from the homestead.buildInfo configuration section,
 * which is populated from environment variables BACKSTAGE_VERSION and HOMESTEAD_BUILD_TIMESTAMP.
 */
export const BuildInfoCard = () => {
  const config = useApi(configApiRef);

  const timestamp = config.getOptionalString('homestead.buildInfo.timestamp');
  const version = config.getOptionalString('homestead.buildInfo.version');

  const rows: BuildInfoRow[] = [
    { id: 'timestamp', key: 'Build Timestamp', value: timestamp || 'Not available' },
    { id: 'version', key: 'Backstage Version', value: version || 'Not available' },
  ];

  const { tableProps } = useTable<BuildInfoRow>({
    mode: 'complete',
    data: rows,
    paginationOptions: { type: 'none' },
  });

  return (
    <Card>
      <CardHeader>
        <Text variant="title-medium">Build Information</Text>
      </CardHeader>
      <CardBody>
        <Table columnConfig={columns} {...tableProps} />
      </CardBody>
    </Card>
  );
};
